/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { NotificationController } from 'components/notifications'
import { showLinks } from 'constants/common';
import styled from '@emotion/styled'
import { isArray } from 'lodash';

const StyledMain = styled('main')`
  background: white;
  padding: ${({isSingleChild}) => isSingleChild ? '64px 0 0 0' : '64px 0.1px 48px' };
  position: relative;
  min-height: ${({ showLink }) => showLink ? 'calc(100vh - 196px)' : 'calc(100vh - 154px)' };
 
`

const Main = ({ children }) => (
  <StyledMain role='main' showLink={showLinks()} isSingleChild={!isArray(children)}>
    <NotificationController />
    {children}
  </StyledMain>
)

Main.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
}

export default Main
